import { Component, OnInit } from '@angular/core';
import { CouponGeneratorComponent } from 'src/app/core/custom-modules/campaign-wizard/coupon-generator/coupon-generator.component';
import { CampaignWizardComponent } from 'src/app/core/custom-modules/campaign-wizard/campaign-wizard.component';
import { debounceTime, filter, distinctUntilChanged, map, finalize, catchError } from 'rxjs/operators';
import { CampaignsFilterComponent } from './campaigns-filter/campaigns-filter.component';
import { DialogService, LanguageService, HelperService, AuthService } from 'src/app/services';
import { ConstantsHelper } from 'src/assets/constants/constants.helper';
import { environment } from 'src/environments/environment';
import { of as observableOf, Subscription } from 'rxjs';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MediaObserver } from '@angular/flex-layout';
import { CampaignsService } from './campaigns.service';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';

@Component({
  selector: 'esc-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.scss']
})
export class CampaignsComponent implements OnInit {

  public listData = [];
  public listLength = 0;
  private currentFilters;
  public filterNumber: number = 0;
  public selectedRow;
  exportData = [];
  public loading = {
    init: false,
    more: false,
    export: false,
    import: false,
    error: false,
  };
  private listSub: Subscription;
  public form: FormGroup;
  public constants = ConstantsHelper;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});

  displayedColumns: string[] = ['actions', 'campaign_name', 'distribution_name', 'status', 'pre_generated', 'on_demand'];

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    public authService: AuthService,
    public campSvc: CampaignsService,
    private dialogService: DialogService,
    private languageService: LanguageService,
  ) { }

  ngOnInit() {
    this.currentFilters = _.cloneDeep(INITIAL_OPTIONS);
    this.initForm();
    this.getListData();
    this.detectFormChanges();
  }

  ngOnDestroy() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
  }

  initForm() {
    this.form = this.fb.group({
      searchTerm: [null],
    });
  }

  getListData() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.listData.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }

    this.listSub = this.campSvc.getList(this.currentFilters).pipe(
      finalize(() => {
        this.listSub.unsubscribe();
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        this.loading.init = false;
        this.loading.more = false;
        if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg)
          return;
        }
        if (_.has(res, 'value') && (res.value == "Success")) {
          this.listData = this.listData.concat(res.data);
          this.listLength = _.get(res, 'count');
        } else {
          this.listData = [];
        }
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      });
  }

  getMoreData() {
    if (this.loading.more || this.loading.init || this.listData.length >= this.listLength) {
      return;
    }
    this.currentFilters.web_filter.offset += this.currentFilters.web_filter.limit;
    this.getListData();
  }

  openWizard(ev: Event, mode, data) {
    if(mode == 'edit') {
      ev.stopPropagation();
    }
    this.selectRow(data);

    let dialogRef: MatDialogRef<CampaignWizardComponent>;
    dialogRef = this.dialogService.openDialog(CampaignWizardComponent, {
      maxWidth: '90vw',
      width: '100%',
      height: '90%',
      autoFocus: false,
      disableClose: true,
      data: {
        mode: _.toLower(mode),
        campaign_distribution_data: data ? data : null
      }
    });
    dialogRef.afterClosed().subscribe((success) => {
      if(success) {
        this.refresh();
      }
      this.selectedRow = null;
    })
  }

  generateCoupon(ev: Event, data) {
    ev.stopPropagation();
    this.selectRow(data);
    let dialogRef: MatDialogRef<CouponGeneratorComponent>;
    dialogRef = this.dialogService.openDialog(CouponGeneratorComponent, {
      width: '500px',
      height: '50%',
      autoFocus: false,
      disableClose: false,
      data: {
        campaign_distribution_data: data ? data : null
      }
    });
    dialogRef.afterClosed().subscribe((success) => {
      if(success) {
        this.refresh();
      }
      this.selectedRow = null;
    })
  }

  openFilter() {
    let dialogRef: MatDialogRef<CampaignsFilterComponent>;
    dialogRef = this.dialogService.openDialog(CampaignsFilterComponent, {
      width: '500px',
      autoFocus: false,
      disableClose: false,
      data: this.currentFilters
    });
    dialogRef.afterClosed().subscribe((selectedFilters) => {
      if(selectedFilters) {
        this.currentFilters.web_filter.distribution_start_date = _.get(selectedFilters, 'distribution_start_date');
        this.currentFilters.web_filter.distribution_end_date = _.get(selectedFilters, 'distribution_end_date');
        this.currentFilters.web_filter.status =  _.get(selectedFilters, 'status');
        this.refresh();
      }
    })
  }

  detectFormChanges() {
    this.form.get('searchTerm').valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.currentFilters.web_filter.keyword = _.toString(value);
      this.refresh();
    });
  }

  selectRow(selectedRow) {
    this.selectedRow = _.cloneDeep(selectedRow);
  }

  refresh() {
    this.listData = [];
    this.listLength = 0;
    this.currentFilters.web_filter.offset = _.clone(INITIAL_OPTIONS.web_filter.offset);
    this.getListData();
  }

  downloadCouponsList(event: Event, element) {
    event.stopPropagation()
    let dialogRef = this.dialogService.loading();
    this.listSub = this.campSvc.downloadCouponsList({ 
      campaign_id: element.campaign_id,
      campaign_code: element.campaign_code,
      ...this.currentFilters
    }).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        dialogRef.close()
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.helper.reportGenerated();
        }
      });
  }

  deleteCampaign(event: Event, element) {
    event.stopPropagation()
    let dialogRef = this.dialogService.confirm({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this campaign?",
    }, { width: '400px' });
    dialogRef.afterClosed().subscribe((success) => {
      if(success) {
        this.loading.init = true;
        this.campSvc.deleteDistribution({
          campaign_id: element.campaign_id,
          distribution_id: element.distribution_id,
          full_name: localStorage.getItem("fullname")
        }).subscribe((res: any) => {
          this.loading.init = false;
          if (environment.showLogs) {
            console.log("Response: ", res);
          }
          if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
            this.dialogService.openSnackBar(this.networkErrMsg);
            return;
          }
          if (res.value && res.value == "Success") {
            this.dialogService.openSnackBar("Deleting campaign. An email will be sent once campaign has been successfully deleted.");
            this.refresh();
          } else if (res.error && res.error.value) {
            this.dialogService.openSnackBar(res.error.value);
          } else {
            this.dialogService.openSnackBar("Unable to delete campaign");
          }
        });
      }
    });
  }
}

const INITIAL_OPTIONS = {
  web_filter: {
    offset: 0,
    limit: 50,
    keyword: "",
    status: [0],
    distribution_start_date: "",
    distribution_end_date: "",
    getMore: true
  }
}